class Component {

    constructor(element) {
        // component configuration
        this.config = {
            handleSelector: '[data-tab-bar-handle]',
            panelSelector: '[data-tab-bar-panel]',
            activeClass: 'is-active'
        };

        // component properties
        this.root = element;
        this.handles = [].slice.call(element.querySelectorAll(this.config.handleSelector));
        this.panels = [].slice.call(document.querySelectorAll(this.config.panelSelector));

        // bind to events
        this.handles.forEach(handle => {
            handle.addEventListener('click', event => this.showTab(event, handle));
        });
    }

    showTab(event, handle) {
        event.preventDefault();

        const panel = this.panels.filter(panel => `#${panel.id}` === handle.hash)[0];
        const isActive = panel.classList.contains(this.config.activeClass);

        if (!isActive) {
            this.handles.forEach(handle => handle.classList.remove(this.config.activeClass));
            handle.classList.add(this.config.activeClass);

            this.panels.forEach(panel => panel.classList.remove(this.config.activeClass));
            panel.classList.add(this.config.activeClass);
        }
    }
}

const enhanceElement = (element) =>
    element ? new Component(element) : false;

const enhance = () =>
    enhanceElement(document.querySelector('[data-tab-bar]'));

export default {enhance};
